import { faArrowLeft, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useApi } from 'ApiHooks'
import ModalBusquedaPedidoGuia from 'Components/ModalBusquedaPedidoGuia'
import ModalConfirmarBorrarSeleccion from 'Components/ModalConfirmarBorrarSeleccion'
import ModalDomicilios from 'Components/ModalDomicilios'
import ModalConfirmarBorrarSeleccionIndividual from 'Components/ModalConfirmarBorrarSeleccionIndividual'
import ModalVistaPreviaPDF from 'Components/ModalVistaPreviaPDF'
import { useBlockUI } from 'Context/BlockUIContext'
import { useErrorModal } from 'Context/ErrorModalContext'
import React, { useEffect, useState } from 'react'
import { Card, Row, Col, Form, Button, Table } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { storageFactory } from 'storage-factory'
import { useIsMobile } from 'utils/Utils'
import ModalErrorAlerta from 'Components/ModalErrorAlerta'
import { Domicilio } from 'Interfaces/Domicilio'

const AltaPedidoGuia = () => {

    const api = useApi()
    const { showBlock, hideBlock } = useBlockUI()
    const { showError } = useErrorModal()
    const isMobile = useIsMobile()
    const storage = storageFactory(() => localStorage)
    const declaranteActual = storage.getItem("declaranteSeleccionado")
    const nombreDeclaranteActual = storage.getItem("nombreDeclaranteSeleccionado")
    const history = useHistory()
    const [envio, setEnvio] = useState<string>('')
    const [declaranteData, setDeclaranteData] = useState<any>(null)
    const [domicilioSeleccionado, setDomicilioSeleccionado] = useState<any>(null)
    const [showModalDomicilios, setShowModalDomicilios] = useState(false)
    const [showModalConfirmarBorrarSeleccionIndividual, setShowModalConfirmarBorrarSeleccionIndividual] = useState(false)
    const [nroLegajo, setNroLegajo] = useState<string>('')
    const [showModalBusquedaPedidoGuia, setShowModalBusquedaPedidoGuia] = useState(false)
    const [showModalErrorAlerta, setShowModalErrorAlerta] = useState(false)
    const [showModalConfirmarBorrarSeleccion, setShowModalConfirmarBorrarSeleccion] = useState(false)
    const [agregarSeleccionados, setAgregarSeleccionados] = useState<any[]>([])
    const [showModalPDF, setShowModalPDF] = useState<boolean>(false)
    const [base64Data, setBase64Data] = useState<string | null>(null)
    const [nroLotePDF, setNroLotePDF] = useState<number | null>(null)
    const [fechaNuevoLote, setFechaNuevoLote] = useState('')
    const [unidadesNegocio, setUnidadesNegocio] = useState<{ value: string, label: string }[]>([])
    const [domicilios, setDomicilios] = useState<Domicilio[]>([])
    const [sucursalRecepcionAndreani, setSucursalRecepcionAndreani] = useState('')

    console.log('agregarSeleccionados', agregarSeleccionados)
    const obtenerDeclaranteData = async () => {
        showBlock("Cargando datos del declarante...")
        try {
            const response = await api.getDespachanteData(declaranteActual!)
            setDeclaranteData(response)
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    const enviarPedido = async () => {
        showBlock("Enviando pedido...")
        try {
            const response = await api.agregarPedidoDigitalizacion({
                domicilio: `${domicilioSeleccionado?.calle ?? ''} ${domicilioSeleccionado?.numero ?? ''} ${domicilioSeleccionado?.piso?.length > 0 ? 'Piso ' + domicilioSeleccionado?.piso : ''} ${domicilioSeleccionado?.departamento?.length > 0 ? 'Depto ' + domicilioSeleccionado?.departamento : ''}`,
                localidad: domicilioSeleccionado?.localidad,
                telefono: domicilioSeleccionado?.telefono,
                email: domicilioSeleccionado?.email,
                observaciones: domicilioSeleccionado?.referencias,
                esAndreani: envio === 'ANDREANI' ? true : false,
                CuitDespachante: declaranteActual!,
                idWsExterno: '',
                despachosSeleccionados:
                    agregarSeleccionados.map((despacho) => ({
                        despacho: despacho?.nroLegajo,
                        unidadNegocio: despacho?.unidadNegocio,
                        referencia: despacho?.referencia,
                        generadorId: despacho?.generadorId
                    })),
                devoluciones: [],
                nuevosDespachos: [],
                codigoSucursalCorreo: domicilioSeleccionado?.codigoSucursalCorreo,
                nroCliente: declaranteData?.nroCliente
            })
            if (response?.nuevoLote?.nrosLote) {
                showBlock("Generando impresión de lotes...")
                setFechaNuevoLote(response?.nuevoLote?.fechaEnvio)
                setNroLotePDF(response.nuevoLote.generadorId ?? response?.nuevoLote?.nrosLote?.[0] ?? null)
                await impresionLotes(response.nuevoLote.nrosLote)
            } else {
                hideBlock()
                showError({
                    title: 'Error al generar impresión de lotes',
                    message: 'No se recibió número de lote generado',
                })
            }
        } catch (error: any) {
            if (!api.isCancel(error)) {
                if (error?.response?.data?.error) {
                    showError({
                        title: 'Error al enviar datos',
                        message: error?.response?.data?.mensaje,
                    })
                } else {
                    showError({
                        title: 'Error al enviar datos',
                        message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                    })
                }

            }
        } finally {
            hideBlock()
        }
    }

    const impresionLotes = async (nrosLotes: [number]) => {
        showBlock("Generando impresión de lotes...")
        try {
            const response = await api.generarImpresionLotes(nrosLotes)
            setBase64Data(response?.formularioStringBase64)
            setShowModalPDF(true)
            hideBlock()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    const obtenerListadoUnidadNegocio = async () => {
        showBlock("Obteniendo listado de unidades de negocio...")
        try {
            const response = await api.obtenerListadoUnidadNegocio(declaranteActual!)
            setUnidadesNegocio(response.map((item: any) => ({
                value: item,
                label: item,
            })))
            hideBlock()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al obtener la lista de unidades de negocio',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            setNroLotePDF(null)
            hideBlock()
        }
    }

    const obtenerDomicilios = async () => {
        setDomicilios([])
        showBlock("Cargando domicilios...")
        try {
            const domicilios = await api.getDomiciliosUsuario()
            setDomicilios(domicilios)

            const domicilio = domicilios?.[0]

            const faltaDato = [
                domicilio?.calle,
                domicilio?.numero,
                domicilio?.codigoPostal,
                domicilio?.telefono,
                domicilio?.provincia,
                domicilio?.localidad
            ].some(v => v == null)

            if (domicilios?.length === 1) {
                if (!faltaDato) {
                    setDomicilioSeleccionado(domicilios?.[0])
                    if (domicilio?.localidadSucursal !== null && domicilio?.codigoSucursalCorreo !== null) {
                        ObtenerSucursalCorreo(domicilio?.codigoSucursalCorreo)
                    }
                }
                //  else {
                //     showError({
                //         title: 'Error al cargar domicilio',
                //         message: 'Faltan datos del domicilio'
                //     })
                // }
            }

        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message,

                })
            }
        } finally {
            hideBlock()
        }
    }

    const ObtenerSucursalCorreo = async (sucursalCorreo: string) => {
        showBlock("Cargando sucursales...")
        try {
            const response = await api.obtenerSucursalCorreo(sucursalCorreo)
            setSucursalRecepcionAndreani(`${response?.direccion_localidad} - ${response?.descripcion}`)
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    const eliminarUno = (nroLegajo: string) => {
        setAgregarSeleccionados(prev =>
            prev.filter(l => l.nroLegajo !== nroLegajo)
        )
    }

    const actualizarCampoFila = (
        nroLegajo: string,
        campo: string,
        valor: any
    ) => {
        setAgregarSeleccionados(prev =>
            prev.map(lote =>
                lote.nroLegajo === nroLegajo
                    ? { ...lote, [campo]: valor }
                    : lote
            )
        )
    }

    const disabledEnviar =
        agregarSeleccionados.length === 0 ||
        envio?.length === 0 ||
        !domicilioSeleccionado ||
        domicilioSeleccionado.length === 0

    const disabledEnviarAndreaSinSucursal = (domicilioSeleccionado?.codigoSucursalCorreo === 0 || domicilioSeleccionado?.codigoSucursalCorreo === null) && envio === 'ANDREANI'

    const mensajeFaltanCampos = [
        agregarSeleccionados.length === 0 && 'Falta agregar pedido de guía a lote',
        (!domicilioSeleccionado || domicilioSeleccionado.length === 0) && 'Falta seleccionar domicilio',
        disabledEnviarAndreaSinSucursal && 'El domicilio seleccionado no tiene una sucursal de Andreani',
        envio?.length === 0 && 'Falta seleccionar el tipo de envío',
    ].filter(Boolean)

    useEffect(() => {
        obtenerDeclaranteData()
        obtenerListadoUnidadNegocio()
        obtenerDomicilios()
        //eslint-disable-next-line react-hooks/exhaustive-deps   
    }, [])

    return (
        <>
            <Card className="shadow-sm border-0 mb-4" style={{ backgroundColor: 'white' }}>
                <Card.Body>
                    <h4 className="mb-4 text-primary fw-bold">
                        <Button variant='warning' className='mr-4' onClick={() => history.goBack()}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                        Detalle del Cliente
                    </h4>

                    <Form>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Usuario</Form.Label>
                                    <Form.Control disabled value={nombreDeclaranteActual!} />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>N° Cliente</Form.Label>
                                    <Form.Control disabled value={declaranteData?.nroCliente} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control disabled value={declaranteData?.nombre} />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="d-flex align-items-end">
                                <Form.Group className="w-100">
                                    <Button
                                        variant="outline-primary"
                                        className="w-100"
                                        onClick={() => setShowModalDomicilios(true)}
                                    >
                                        Seleccionar domicilio
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Domicilio</Form.Label>
                                    <Form.Control disabled value={(domicilioSeleccionado?.calle ?? '') + ' ' + (domicilioSeleccionado?.numero ?? '') + ' ' + (domicilioSeleccionado?.piso ?? '') + ' ' + (domicilioSeleccionado?.departamento ?? '')} />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Localidad</Form.Label>
                                    <Form.Control disabled value={domicilioSeleccionado?.localidad} />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control disabled value={domicilioSeleccionado?.telefono} />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row>
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Observaciones</Form.Label>
                                    <Form.Control as="textarea" disabled value={domicilioSeleccionado?.referencias} rows={1} />
                                </Form.Group>

                            </Col>
                        </Row>
                        {sucursalRecepcionAndreani !== '' && <Row>
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Sucursal de Recepción Andreani</Form.Label>
                                    <Form.Control as="textarea" disabled value={sucursalRecepcionAndreani} rows={1} />
                                </Form.Group>

                            </Col>
                        </Row>}
                        <hr />

                        <Row className="align-items-center">
                            <Col xs="auto">
                                <h4 className="mb-4 text-primary fw-bold">
                                    Forma de Envío:
                                </h4>
                            </Col>

                            <Col xs={5}>
                                <Button
                                    variant={envio === 'BANK' ? 'primary' : 'outline-primary'}
                                    onClick={() => setEnvio('BANK')}
                                    className="w-100"
                                    disabled={domicilioSeleccionado?.length === 0 || !domicilioSeleccionado}
                                >
                                    <img src='/favicon-32x32.png' width={36} alt='logo_bank' /> BANK

                                </Button>
                                <p style={{ fontSize: 15, fontWeight: 'bold' }}>{envio === 'BANK' && 'Legajos retirados por Bank'}</p>
                            </Col>

                            <Col xs={5}>
                                <Button
                                    variant={envio === 'ANDREANI' ? 'primary' : 'outline-primary'}
                                    onClick={() => setEnvio('ANDREANI')}
                                    className="w-100 p-0"
                                    disabled={domicilioSeleccionado?.length === 0 || !domicilioSeleccionado}
                                >
                                    <img
                                        src="/logo_andreani.svg"
                                        alt='logo_andreani'
                                        style={{
                                            height: '100%',
                                            maxHeight: 48,
                                            width: 'auto',
                                            display: 'block',
                                            margin: 'auto'
                                        }}
                                    />
                                </Button>
                                <p style={{ fontSize: 15, fontWeight: 'bold' }}>{envio === 'ANDREANI' && 'Entregar legajos en la sucursal de Andreani'}</p>

                            </Col>
                        </Row>
                        {disabledEnviarAndreaSinSucursal && <h4 style={{ color: 'red' }}>El domicilio seleccionado no tiene una sucursal de Andreani</h4>}
                    </Form>
                    <hr />
                    <h4 className="mb-4 text-primary fw-bold">Agregar Pedidos de Guia a Lote</h4>
                    <Row>
                        <Col md="auto">
                            <Button type='primary' onClick={(e) => {
                                e?.preventDefault()
                                setShowModalBusquedaPedidoGuia(true)
                            }}><FontAwesomeIcon icon={faSearch} />Buscar despachos a seleccionar</Button>
                            <p>{agregarSeleccionados?.length > 0 ? `${agregarSeleccionados.length} despachos seleccionados` : 'No hay despachos seleccionados'}</p>
                        </Col>
                        <Col>
                            {agregarSeleccionados.length > 0 && (
                                <div className="d-flex gap-2 mb-2 flex-wrap" style={{ marginTop: isMobile ? 10 : 0 }}>
                                    <Button variant='danger' disabled={agregarSeleccionados.length === 0} onClick={() => setShowModalConfirmarBorrarSeleccion(true)}><FontAwesomeIcon icon={faTrash} />
                                        Quitar todos
                                    </Button>
                                </div>
                            )}

                        </Col>
                    </Row>

                    <Row style={{ flexDirection: isMobile ? 'column' : 'row' }}>
                        {isMobile ? (
                            <div className="d-md-none mt-2">
                                {agregarSeleccionados?.map((lote: any) => (
                                    <Card key={lote.generadorId} className="mb-2 shadow-sm" style={{ backgroundColor: 'white' }}>
                                        <Card.Body>


                                            <div className="mb-1">
                                                <strong>Despacho:</strong> {lote.nroLegajo}
                                            </div>
                                            <div className="mb-1">
                                                <strong>Código:</strong> {lote.codigo}
                                            </div>
                                            <div className="mb-1">
                                                <strong>Cuit Impo/Expo:</strong> {lote.cuitIE}
                                            </div>
                                            <div className="mb-1">
                                                <strong>Nombre Impo/Expo:</strong> {lote.descIE}
                                            </div>
                                            <div className="mb-1">
                                                <strong>Fecha ENDO:</strong> {lote.fechaEndo ?? "N/A"}
                                            </div>

                                            <div className="mb-1">
                                                <strong>Sigea:</strong> {lote.sigea}
                                            </div>
                                            <div className="mb-1">
                                                <Form.Label>Unidad de Negocio</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    size="sm"
                                                    value={lote.unidadNegocio || ''}
                                                    onChange={(e) =>
                                                        actualizarCampoFila(
                                                            lote.nroLegajo,
                                                            'unidadNegocio',
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">Seleccionar</option>
                                                    {unidadesNegocio.map(u => (
                                                        <option key={u.value} value={u.value}>
                                                            {u.label}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </div>


                                            <div className="mb-1">
                                                <Form.Label>Referencia</Form.Label>

                                                <Form.Control
                                                    size="sm"
                                                    type="text"
                                                    placeholder="Referencia"
                                                    value={lote.referencia || ''}
                                                    onChange={(e) =>
                                                        actualizarCampoFila(
                                                            lote.nroLegajo,
                                                            'referencia',
                                                            e.target.value
                                                        )
                                                    }
                                                />                                            </div>

                                            <Button
                                                size="sm"
                                                variant="outline-danger"
                                                onClick={() => {
                                                    setNroLegajo(lote.nroLegajo)
                                                    setShowModalConfirmarBorrarSeleccionIndividual(true)
                                                }}
                                                className="w-100 mt-2"
                                            >
                                                Quitar
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </div>
                        ) : (
                            <div className="table-responsive lotes-table mt-2">
                                <Table hover size="sm" className="mb-0">
                                    <thead className="thead-light">
                                        <tr>

                                            <th>Despacho</th>
                                            <th>Código</th>
                                            <th>Cuit Impo/Expo</th>
                                            <th>Nombre Impo/Expo</th>
                                            <th>Fecha ENDO</th>
                                            <th>SIGEA</th>
                                            <th>Únidad Negocio</th>
                                            <th>Referencia</th>
                                            <th>Acciones</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {agregarSeleccionados?.map((lote: any) => (
                                            <tr key={lote.generadorId}>

                                                <td>{lote.nroLegajo}</td>
                                                <td>{lote.codigo}</td>
                                                <td>{lote.cuitIE}</td>
                                                <td>{lote.descIE}</td>
                                                <td>
                                                    {lote.fechaEndo
                                                        ?? "N/A"}
                                                </td>
                                                <td>{lote.sigea}</td>

                                                <td style={{ minWidth: 160 }}>
                                                    <Form.Control
                                                        as="select"
                                                        size="sm"
                                                        value={lote.unidadNegocio || ''}
                                                        onChange={(e) =>
                                                            actualizarCampoFila(
                                                                lote.nroLegajo,
                                                                'unidadNegocio',
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {unidadesNegocio.map(u => (
                                                            <option key={u.value} value={u.value}>
                                                                {u.label}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </td>

                                                <td style={{ minWidth: 180 }}>
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        placeholder="Referencia"
                                                        value={lote.referencia || ''}
                                                        onChange={(e) =>
                                                            actualizarCampoFila(
                                                                lote.nroLegajo,
                                                                'referencia',
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <Button
                                                        size="sm"
                                                        variant="outline-danger"
                                                        onClick={() => {
                                                            setNroLegajo(lote.nroLegajo)
                                                            setShowModalConfirmarBorrarSeleccionIndividual(true)
                                                        }}
                                                    >
                                                        Quitar
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </Row>
                </Card.Body>
                <Button variant='primary' onClick={() => {
                    disabledEnviar || disabledEnviarAndreaSinSucursal ? setShowModalErrorAlerta(true) : enviarPedido()
                }}>Enviar pedido</Button>
            </Card>

            <ModalDomicilios
                showModalDomicilios={showModalDomicilios}
                setShowModalDomicilios={setShowModalDomicilios}
                onClose={() => setShowModalDomicilios(false)}
                hiddenSelectButton={false}
                faltaDatoDomicilio={false}
                onSelect={(dom) => {
                    setDomicilioSeleccionado(dom)
                    setShowModalDomicilios(false)
                    dom?.codigoSucursalCorreo !== 0 && ObtenerSucursalCorreo(dom?.codigoSucursalCorreo?.toString())
                }}
                obtenerDomicilios={obtenerDomicilios}
                domiciliosData={domicilios}
            />

            <ModalErrorAlerta
                show={showModalErrorAlerta}
                setShow={setShowModalErrorAlerta}
                modalErrorMessage={mensajeFaltanCampos?.map((m, i) => (
                    <div key={i}>• {m}</div>
                ))}
                modalTitle='Faltan campos'
            />
            <ModalBusquedaPedidoGuia
                show={showModalBusquedaPedidoGuia}
                setShow={setShowModalBusquedaPedidoGuia}
                pedidosAgregados={agregarSeleccionados}
                setAgregarSeleccionados={(nuevos) => {
                    setAgregarSeleccionados(prev => {
                        const map = new Map(prev.map(l => [l.nroLegajo, l]))

                        nuevos.forEach(l => {
                            map.set(l.nroLegajo, l)
                        })
                        return Array.from(map.values())
                    })
                }}
            />

            <ModalConfirmarBorrarSeleccion
                show={showModalConfirmarBorrarSeleccion}
                setShow={setShowModalConfirmarBorrarSeleccion}
                setAgregarSeleccionados={setAgregarSeleccionados}
            />
            <ModalVistaPreviaPDF
                showModalVistaArchivo={showModalPDF}
                handleCloseModalVisualizarArchivo={() => {
                    setShowModalPDF(false)
                    setBase64Data(null)
                    history.replace('/lotes')
                }}
                base64Archivo={base64Data!}
                nombreArchivo={envio === 'ANDREANI' ? `BANK_Pedido_guia_Andreani_${fechaNuevoLote}.pdf` : `BANK_Pedido_guia_${nroLotePDF}.pdf`}
            />
            <ModalConfirmarBorrarSeleccionIndividual
                show={showModalConfirmarBorrarSeleccionIndividual}
                setShow={setShowModalConfirmarBorrarSeleccionIndividual}
                quitarSeleccionado={() => {
                    eliminarUno(nroLegajo)
                    setNroLegajo('')
                }
                }
            />
        </>
    )
}

export default AltaPedidoGuia
